<div class="footer">
    <div class="all-rights centered" id="firstRightsLine">
        <p >{{ companyName }}&nbsp;{{ (displayHiphen ? '-' : '') }}&nbsp;</p>
        <p >{{ ('footer.allRights' | translate) }}</p>
    </div>
</div>
